import { render, staticRenderFns } from "./UserBadges.vue?vue&type=template&id=0119ee47&scoped=true&"
import script from "./UserBadges.vue?vue&type=script&lang=ts&"
export * from "./UserBadges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119ee47",
  null
  
)

export default component.exports